import { Popover, Select } from "antd";
import classNames from "classnames";
import PropTypes from "prop-types";
import CanvasIcon from "./CanvasIcon";
import { ICON_PATHS } from "./step-look";

const ScreenShareMenu = ({ share, withLabel }) => {
  const { labels, options, value, ignored, onChange } = share;
  const content = (
    <div className="screen-share-menu">
      <strong className="screen-share-menu__title">{labels.TITLE}</strong>
      <Select
        allowClear
        showSearch
        virtual={false}
        className="screen-share-menu__select"
        aria-label={labels.TITLE}
        placeholder={labels.PLACEHOLDER}
        optionFilterProp="label"
        options={options}
        value={value || undefined}
        getPopupContainer={(node) => node.parentElement}
        onChange={(next) => onChange(next || null)}
      />
      <span className="screen-share-menu__note">
        {ignored ? labels.IGNORED : labels.HINT}
      </span>
    </div>
  );

  return (
    <Popover trigger="click" placement="bottomRight" content={content}>
      <button
        type="button"
        aria-label={labels.TITLE}
        title={labels.TITLE}
        aria-pressed={Boolean(value)}
        className={classNames(
          "workshop-stage__tool",
          "screen-share-menu__button",
          {
            "workshop-stage__tool--on": Boolean(value),
            "screen-share-menu__button--icon": !withLabel,
          },
        )}
      >
        <CanvasIcon path={ICON_PATHS.layers} size={16} strokeWidth={1.9} />
        {withLabel ? labels.TITLE : null}
      </button>
    </Popover>
  );
};

ScreenShareMenu.propTypes = {
  share: PropTypes.shape({
    labels: PropTypes.shape({
      TITLE: PropTypes.string,
      PLACEHOLDER: PropTypes.string,
      HINT: PropTypes.string,
      IGNORED: PropTypes.string,
    }).isRequired,
    options: PropTypes.arrayOf(
      PropTypes.shape({ value: PropTypes.string, label: PropTypes.string }),
    ).isRequired,
    value: PropTypes.string,
    ignored: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
  }).isRequired,
  withLabel: PropTypes.bool,
};

ScreenShareMenu.defaultProps = {
  withLabel: false,
};

export default ScreenShareMenu;
